<template>
  <v-dialog :isActive="open" v-model="open" width="500" class="modal" data-app>
    <div id="popup">
      <div class="header">
        <img v-bind:src="'/img/success.svg'" alt="check">
        <h6>{{$t('success.info_updated')}}</h6>
      </div>
      <div class="buttons">
        <button v-on:click="cancel()" class="btn">{{$t('dissolve')}}</button>
      </div>
    </div>
  </v-dialog>
</template>
<script>

import i18n from '@/i18n';

export default {
    name: 'SuccessPopup',
    props:['dialog'],
    data() {
        return {
            open: false
        }
    },
    methods: {
        cancel() {
            // close dialog
            this.open = false;
            this.$emit('close');
        }
    },
    watch: {
        'dialog': function(){
            this.open = this.dialog;
        },
        'open': function(){
            if(!this.open){
                this.$emit('close');
            }
        }
    }

}
</script>

<style lang="scss" scoped>
#popup {
    height: 200px;
    background-color: white;
    .header {
        padding-top: 10px;
        h6 {
            text-align: center;
        }
        img {
            display: block;
            text-align: center;
            margin: 0 auto;
            padding-top: 10px;
            width: 50px;
            height: 50px;
        }
    }

    .buttons {
        .btn {
            margin: 0 auto;
            text-align: center;
            display: block;
            min-width: 40px;
            padding: 0 35px;
            outline: none;
            cursor: pointer;
            font-size: 16px;
            border-radius: 3px;
            -webkit-transition: all 0.5s;
            transition: all 0.5s;
            color: #c55c00;
            height: 40px;
            line-height: 40px;
            text-transform: uppercase;
            background-color: transparent;
            font-family: AvantGarde-Bold;
            max-width: 300px;
            transition: background-color 0.5s ease;
            border: 1px solid #fc8926;

            &:hover {
                background-color: #fc8a2623 !important;
            }

        }

    }

}
</style>